<template>
  <div class="mm-button" :loading="loading">
    <el-popover placement="bottom-end" trigger="hover">
      <div class="spaceLeft">
        <img class="mm-logo" src="../../../assets/logo/mm-logo.png">
        <account v-if="account" class="mm-text" :value="account" />
        <el-button v-else type="text" class="mm-text" @click="connectMetaMask">{{ btnText }}</el-button>
      </div>
      <div slot="reference">
        <img v-if="btnText == 'Connected'" class="asset-img" src="@/assets/image/login/assetLogin.svg">
        <img v-else class="asset-img" src="@/assets/image/login/assetLogout.svg">
      </div>
    </el-popover>
  </div>
</template>

<script>
import MetaMaskOnboarding from '@metamask/onboarding'
import metaMask from './metaMask.js'
import { CheckAccount } from '@/layout/components/metaMaskInit/accountHandler.js'
import { logoutAndRedirectToSign } from '@/utils/session-navigation'
import { getEthereum } from '@/utils/runtime-globals'
import { connectWallet, ensureWalletChain } from '@/utils/wallet-runtime'
export default {
  data() {
    return {
      isInstall: true,
      isConnect: false,
      btnText: 'Install MetaMask',
      loading: false,
      isLog: true,
      account: undefined
    }
  },
  created() {
    this.init().then((res) => {
      const ethereum = getEthereum()
      this.joinNet()
      this.$store.commit('app/SET_MATEMASK', { initOk: true })
      if (!ethereum) {
        return
      }
      ethereum.autoRefreshOnNetworkChange = false
      CheckAccount()
      // 监听钱包切换
      const self = this
      ethereum.on('accountsChanged', function(accounts) {
        logoutAndRedirectToSign({
          store: self.$store,
          router: self.$router,
          route: self.$route,
          reason: 'wallet-account-changed'
        })
      })
      // 监听链网络改变
      ethereum.on('chainChanged', (chainId) => {
        sessionStorage.setItem('TREASURE_CHAINID', chainId)
        if (this.$store.getters.metaMaskObj.stopRefreshJoinNet) {
          this.$store.commit('app/SET_MATEMASK', { chainId: chainId })
          if (chainId !== process.env.VUE_APP_CHAINID) {
            this.$message.error('connection failed! ')
          }
        } else {
          window.location.reload()
        }
      })
    })
  },
  methods: {
    async init() {
      return new Promise((reslove) => {
        this.isInstall = metaMask.isMetaMaskInstalled()
        this.$store.commit('app/SET_MATEMASK', { isInstall: this.isInstall })
        if (this.isInstall) {
          this.connectMetaMask(reslove)
        } else {
          reslove('not install')
        }
      })
    },
    connectMetaMask(reslove) {
      if (this.isConnect) {
        return
      }
      if (!this.isInstall) {
        // window.open("https://metamask.io/download/")
        this.loading = true
        this.btnText = 'Onboarding in progress'
        const onboarding = new MetaMaskOnboarding()
        onboarding.startOnboarding()
        reslove()
      } else {
        this.loading = false
        this.btnText = 'Connect Wallet'
        this.onClickConnect(reslove)
      }
    },
    async onClickConnect(reslove) {
      try {
        const ethereum = getEthereum()
        if (!ethereum) {
          this.$store.commit('app/SET_MATEMASK', { isConnect: false })
          reslove()
          return
        }
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        this.loading = true
        const account = await connectWallet()
        if (!account) {
          this.$message.error('Not able to get accounts')
        } else {
          this.account = account
          this.btnText = 'Connected'
          this.isConnect = true
          this.$store.commit('app/SET_MATEMASK', {
            isConnect: true,
            account
          })
        }
        reslove()
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$store.commit('app/SET_MATEMASK', { isConnect: false })
        reslove()
      }
    },
    async joinNet() {
      try {
        const ethereum = getEthereum()
        if (!ethereum) {
          this.loading = false
          this.$store.commit('app/SET_MATEMASK', { isJoinNet: false })
          return
        }
        await ensureWalletChain()
        this.$store.commit('app/SET_MATEMASK', { isJoinNet: true })
      } catch (error) {
        this.loading = false
        this.$store.commit('app/SET_MATEMASK', { isJoinNet: false })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mm-button {
  display: inline-block;
  background: transparent;
  cursor: pointer;
  color: #1f1f1f;
  margin: 0 0.32rem 0 0;

  .asset-img {
    height: 0.19rem;
    position: relative;
    top: 0.01rem;
  }
}

.mm-logo {
  height: 0.26rem;
  margin-right: 0.16rem;
  position: relative;
  top: 0.03rem;
}

.mm-text {
  position: relative;
  top: 0.02rem;
}
</style>
